module.exports = __webpack_public_path__ + "static/media/finalen.ef6813b1.svg";